import { applyMiddleware, combineReducers, createStore } from "redux";
import persistReducer from "redux-persist/es/persistReducer";
import authReducer from "../reducers/authReducer";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import thunk from "redux-thunk";
import profileSettingsReducer from "../reducers/profileSettingsReducer";
import caseReducer from "../reducers/caseReducer";
import dentalRecordReducer from "../reducers/dentalRecordReducer";
import generalReducer from "../reducers/generalReducer";
import caseRegistratiojnReducer from "../reducers/age-assessment/caseRegistrationReducer";
import imageAnalysisReducer from "../reducers/imaga-analysis/imageAnalysisReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  settings_data: profileSettingsReducer,
  cases: caseReducer,
  dental: dentalRecordReducer,
  general: generalReducer,
  ageAssessmentCase: caseRegistratiojnReducer,
  analysis: imageAnalysisReducer,
});
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const Store = createStore(persistedReducer, applyMiddleware(thunk));
export const persistor = persistStore(Store);
